// Popup

import './index.scss';

export default class Popup {
    constructor(root) {
        this.root = root;
        if (!this.root.id) { return; }

        document.querySelectorAll('[data-popup-open="' + this.root.id + '"]').forEach((button) => {
            button.addEventListener('click', this.open.bind(this));
        });

        this.root.querySelectorAll('.overlay, .panel__close, [data-popup-close]').forEach((button) => {
            button.addEventListener('click', this.close.bind(this));
        });
    }

    open(event) {
        if (event) { event.preventDefault(); }

        this.root.style.display = 'block';
        window.app.disableScrolling();
    }

    close(event) {
        if (event) { event.preventDefault(); }

        window.app.enableScrolling();
        this.root.style.display = 'none';
    }
}
